module.exports = __webpack_public_path__ + "img/user.79b6e217.png";